import { TranslateService } from '@ngx-translate/core';
import { arrowRenderToExpand, genericStringFormatter, restorePointRender, storageRender, policyRender, ongoingRenderVapp, lastBackupRenderVapp, activityLogRenderVapp } from '../../dataprotection-common/common-renderers';

export function getDatatableConfig(translate:TranslateService) {
    return {
        dom: 'Bfrtip',
        columns: [
            { "data": null, "width": "1px", "title": '&nbsp;'},
            { "data": null, "width": "1px", "title": '&nbsp;'},
            { "data": "name", "width": "20%", "title": translate.instant('dpsModule.vapps.grid.header.vapp')},
            { "data": "policy", "width": "26%", "title": translate.instant('dpsModule.vapps.grid.header.backupPolicy')},
            { "data": "restorePoints", "width": "14%", "title": translate.instant('dpsModule.vapps.grid.header.restorePoints')},
            { "data": "lastBackup", "width": "18%", "title": translate.instant('dpsModule.vapps.grid.header.lastBackup')},
            { "data": "storage", "width": "10%", "title": translate.instant('dpsModule.vapps.grid.header.storage')},
            { "data": null, "width": "12%", "title": translate.instant('dpsModule.vapps.grid.header.activityLog')},
            { "data": "lastBackupForSort", "width": "0%", "title": ""}
        ],
        columnDefs: [
            {
                "targets": [ 0 ],
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return arrowRenderToExpand(data, type, row, "vms");
                }
            },
            {
                "targets": [ 1 ],
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return ongoingRenderVapp(data, type, row);
                }
            },
            {
                "targets": [ 2 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                    return genericStringFormatter(data);
                    }
                    return data;
                }
            },
            {
                "targets": [ 3 ],
                "bSortable": false,
                "mRender": function ( data, type, row ) {
                    return policyRender(data, type, row);
                }
            },
            {
                "targets": [ 4 ],
                "className": "dt-body-right",
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                    return restorePointRender(data, type, row);
                    }
                    return ((row && row.statistics && row.statistics.restorePointCount) ? row.statistics.restorePointCount : 0);
                }
            },
            {
                "targets": [ 5 ],
                "orderData":[ 8 ],
                "mRender": function ( data, type, row ) {
                    return genericStringFormatter(lastBackupRenderVapp(data, type, row));
                }
            },
            {
                "targets": [ 6 ],
                "className": "dt-body-right",
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                    return storageRender(data, type, row);
                    }
                    return ((row && row.statistics && row.statistics.storageConsumed) ? row.statistics.storageConsumed : 0);
                }
            },
            {
                "targets": [ 7 ],
                "className": "dt-body-center",
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return activityLogRenderVapp(data, type, row);
                }
            },
            {
                "targets": [ 8 ],
                "visible": false,
                "type": "date-sort-custom",
                "searchable": false,
                "mRender": function ( data, type, row ) {
                    return lastBackupRenderVapp(data, type, row);
                }
            }
        ],
        "autoWidth": false,
        "oLanguage": {
            "sSearch": "",
            "sEmptyTable": translate.instant('dpsModule.vapps.grid.message.emptyTable'),
            "sInfoEmpty": translate.instant('dpsModule.vapps.grid.message.infoEmpty')
        },
        "scrollY":        "50vh",
        "scrollCollapse": true,
        "paging":         false,
        "bFilter": true,
        'bDestroy': true,
        "bUseRendered": false,
        "order": [[ 0, "desc" ]],
        "rowCallback": function( row, data ) {
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vapps/vapps.dt.config.ts